import React, { useContext } from 'react';
import { Column, Row } from '@honda-canada/design-system-react';

import ArticleCard from './ArticleCard';
import HeaderContext from '../service/HeaderContext';
import MenuHeader from './MenuHeader';
import { getGtmTitleValue } from '../../../utils/gtmEvents';

const MenuTypeCard = ({ ctaLink, parentDisplayName, items }) => {
  const { styles, setActiveMenu } = useContext(HeaderContext);

  return (
    <>
      <MenuHeader ctaLink={ctaLink} parentDisplayName={parentDisplayName} />
      <Row>
        {items[0].items?.map(item => (
          <Column key={item?.itemId} data-testid="header-item-submenu-item" {...styles.headerItemSubmenuItem}>
            <ArticleCard
              key={item?.itemId}
              item={item}
              parentDisplayName={parentDisplayName}
              gtmTitle={getGtmTitleValue(item?.gtmTitle, item?.gtmBodyStyle, item?.itemDisplayName)}
              onClick={() => setActiveMenu(null)}
            />
          </Column>
        ))}
      </Row>
    </>
  );
};

export default MenuTypeCard;
